import React, { FC } from 'react';
import styles from './error.module.css';
import SubmitButton from '../submit-button/submit-button';

const ErrorComponent: FC<{ type: 'general' | 'contentFull' }> = ({ type }) => {
  const renderErrorMessage = () => {
    return (
      <div className={styles.errorMessage}>
        <h2>Algo deu errado, por favor tente novamente!</h2>
        <SubmitButton
          value='recarregar'
          variant='secondary'
          onClick={() => window.location.reload()}
        />
      </div>
    );
  };

  const renderErrorContainer = () => {
    switch (type) {
      case 'general':
        return (
          <div className={styles.errorGeneralContent}>
            <div className={styles.errorGeneralAside}></div>
            <div className={[styles.errorGeneralMain, 'shadow-box'].join(' ')}>
              {renderErrorMessage()}
            </div>
          </div>
        );
      case 'contentFull':
        return (
          <div className={[styles.errorContentFull, 'shadow-box'].join(' ')}>
            {renderErrorMessage()}
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <div
      className={
        type === 'general' ? styles.errorGeneralContainer : styles.error
      }
    >
      {renderErrorContainer()}
    </div>
  );
};

export default ErrorComponent;
